import ChatListItem, { ChatListItemProps } from "../../ChatListItem";
import { IBroadcastChatData } from "@home-health-notify/domain";

interface BroadcastChatListItemProps {
  chatData: IBroadcastChatData;
  isSelected: boolean;
}

function BroadcastChatListItem({
  chatData,
  isSelected,
}: BroadcastChatListItemProps) {
  let broadcastInfo = chatData.broadcastInfo;
  const chatItemProps: ChatListItemProps = {
    chatData,
    isSelected,
    avatarText: broadcastInfo.name,
    title: broadcastInfo.name,
    groupType: broadcastInfo.groupType,
  };
  return <ChatListItem {...chatItemProps} />;
}

export default BroadcastChatListItem;
